import {
  CreateAdFlowForm,
  isValidCanadianPostalCode,
} from 'components/createAd/createAdFlowState'

export const CREATE_AD_STREET_MIN = 5
export const CREATE_AD_STREET_MAX = 120
export const CREATE_AD_UNIT_MAX = 15
export const CREATE_AD_CITY_MAX = 40
export const CREATE_AD_NEIGHBORHOOD_MAX = 60

export function sanitizeStreetInput(value: string): string {
  return value.slice(0, CREATE_AD_STREET_MAX)
}

export function sanitizeUnitInput(value: string): string {
  return value.slice(0, CREATE_AD_UNIT_MAX)
}

export function sanitizeCityInput(value: string): string {
  return value.slice(0, CREATE_AD_CITY_MAX)
}

export function sanitizeNeighborhoodInput(value: string): string {
  return value.slice(0, CREATE_AD_NEIGHBORHOOD_MAX)
}

/** Formats as `A1A 1A1` while typing; letters uppercased, alphanumeric only. */
export function formatCanadianPostalCodeInput(value: string): string {
  const compact = value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 6)
  if (compact.length <= 3) return compact
  return `${compact.slice(0, 3)} ${compact.slice(3)}`
}

export function isValidStreet(value: string): boolean {
  const trimmed = value.trim()
  return trimmed.length >= CREATE_AD_STREET_MIN && trimmed.length <= CREATE_AD_STREET_MAX
}

export function isValidUnit(value: string): boolean {
  const trimmed = value.trim()
  if (!trimmed) return true
  return trimmed.length <= CREATE_AD_UNIT_MAX
}

export function isValidCity(value: string): boolean {
  const trimmed = value.trim()
  return trimmed.length >= 1 && trimmed.length <= CREATE_AD_CITY_MAX
}

export function isValidNeighborhood(value: string): boolean {
  const trimmed = value.trim()
  if (!trimmed) return true
  return trimmed.length <= CREATE_AD_NEIGHBORHOOD_MAX
}

export function hasGeocodedAddress(form: Pick<CreateAdFlowForm, 'latitude' | 'longitude'>): boolean {
  return (
    form.latitude != null &&
    form.longitude != null &&
    Number.isFinite(form.latitude) &&
    Number.isFinite(form.longitude)
  )
}

export function isCreateAdAddressStepValid(form: CreateAdFlowForm): boolean {
  return (
    isValidStreet(form.street) &&
    isValidUnit(form.unit) &&
    isValidCity(form.city) &&
    isValidNeighborhood(form.neighborhood) &&
    isValidCanadianPostalCode(form.postalCode) &&
    hasGeocodedAddress(form)
  )
}
